<template>
  <div>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <van-image
          width="100%"
          height="100%"
          fit="contain"
          src="/static/images/img_qkier.jpg"
        />
      </van-swipe-item>
    </van-swipe>

    <div style="padding: 10px;">

      <div style="white-space: pre-wrap;text-align: center;font-size: 16pt;">
        邀请有礼-轻客注册
      </div>
      <div style="text-align: left;">
        <van-field v-model="phone" type="tel" maxlength="11" label="手机号" placeholder="请输入手机号"/>
        <van-field
          v-model="verifyCode"
          type="digit"
          center
          clearable
          label="短信验证码"
          placeholder="请输入短信验证码"
          maxlength="6"
        >
          <template #button>
            <van-button size="small" type="primary" color="#46C9BA" v-on:click="sendVerifyCode">发送验证码</van-button>
          </template>
        </van-field>

        <div style="padding-top: 35px;"></div>
        <van-button type="primary" color="#46C9BA" block v-on:click="verifyAccount">注册轻客账户</van-button>
        <div style="padding-top: 20px;"></div>
        <div style="white-space: pre-wrap;text-align: left;font-size: 10pt;color:red;">
          温馨提示：
          1、邀请有礼活动仅对新用户注册有效。
          2、注册代表您已同意轻客用户协议。
          3、注册成功后，请下载【创维轻客】APP进行使用。
          4、客服电话:4008855227。
        </div>

      </div>
      <div style="white-space: pre-wrap;text-align: center;">
        <van-list @load="onLoad"></van-list>
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    data () {
      return {
        phone: '',
        verifyCode: ''
      }
    },
    methods: {
      onLoad: function () {
        console.log('onload...')

        let customerId = this.$route.query.customerId
        console.log(customerId)

      },
      sendVerifyCode () {
        if (this.phone == null || this.phone.length != 11) {
          this.$toast.fail('手机号格式不正确!')
          return
        }

        let data = new FormData()
        data.append('phone', this.phone)

        this.$axios.post('/api/usershare/invite/send-verifycode', data).then(res => {
          if (res.data.success) {
            this.$toast.success('验证码发送成功!')
          } else {
            this.$toast.fail('操作失败，原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          this.$toast.fail('操作失败!')
        })

      },

      verifyAccount () {
        if (this.phone == null || this.phone.length != 11) {
          this.$toast.fail('手机号格式不正确!')
          return
        }

        if (this.verifyCode == null || this.verifyCode.length != 6) {
          this.$toast.fail('请输入正确的短信验证码!')
          return
        }

        let customerId = this.$route.query.customerId

        let data = new FormData()
        data.append('phone', this.phone)
        data.append('verifyCode', this.verifyCode)
        data.append('customerId', customerId)

        this.$axios.post('/api/usershare/invite/useraccount-register', data).then(res => {
          if (res.data.success) {
            this.$dialog.alert({
              message: res.data.userObject,
            }).then(() => {
              // on close，跳转到轻客下载页面
              window.location.href = 'http://dl.qkier.cn/app'
            })
            //跳转至轻客下载页面

          } else {
            this.$toast.fail('注册失败，原因：' + res.data.msg + '!')
          }
        }).catch(error => {
          this.$toast.fail('注册失败!')
        })

      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/pages/share/UserShareInvite.vue